var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "profitability" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _c("div", { staticClass: "top" }, [
        _c("div", [
          _vm.language === "zh"
            ? _c("span", { staticClass: "zh_income" }, [
                _vm._v("基本每股收益 "),
              ])
            : _vm.language === "en"
            ? _c("span", { staticClass: "en_income" }, [_vm._v("Basic EPS ")])
            : _vm._e(),
          _c("span", { staticClass: "money" }, [
            _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.jbmgsy)),
            _vm.language === "zh"
              ? _c("span", { staticClass: "unit" }, [
                  _vm._v(_vm._s(_vm.jbmgsyUnit)),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "cards" }, [
        _vm.mll
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("毛利率"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n            " + _vm._s(_vm.mll)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.mllUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("Gross Margin"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n            " + _vm._s(_vm.mll)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.mllUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart1", staticClass: "charts" }),
            ])
          : _vm._e(),
        _vm.jzcsyl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("净资产收益率"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n            " + _vm._s(_vm.jzcsyl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.jzcsylUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          " "
                      ),
                      _c("span", { staticClass: "card-text" }, [_vm._v("ROE")]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n            " + _vm._s(_vm.jzcsyl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.jzcsylUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart2", staticClass: "charts" }),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }